(() => {
  const CLIENT_ID = window.bruPayPalClientId;
  const CONTAINER_CLASS = 'bru-paypal-message';
  const CURRENCY = 'EUR';
  const LOCALE = 'es_ES';

  if (!CLIENT_ID) return;

  let sdkPromise = null;

  const parsePrice = text => {
    if (!text) return null;

    const cleaned = text.replace(/[^0-9,.-]/g, '').trim();
    if (!cleaned) return null;

    // Spanish formatting: "." is a thousands separator, "," is the decimal separator.
    const normalized = cleaned.replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
    const value = parseFloat(normalized);

    return isNaN(value) ? null : value;
  };

  const loadSdk = () => {
    if (sdkPromise) return sdkPromise;

    sdkPromise = new Promise((resolve, reject) => {
      if (window.paypal && window.paypal.Messages) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src =
        'https://www.paypal.com/sdk/js?client-id=' +
        encodeURIComponent(CLIENT_ID) +
        '&components=messages&currency=' +
        CURRENCY +
        '&locale=' +
        LOCALE;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('bru-paypal-message: failed to load PayPal SDK'));
      document.head.appendChild(script);
    });

    return sdkPromise;
  };

  const insertMessages = () => {
    const priceBlocks = document.querySelectorAll('.product-card-head__price');
    if (!priceBlocks.length) return;

    priceBlocks.forEach(priceBlock => {
      const parent = priceBlock.parentElement;
      if (!parent) return;

      const next = priceBlock.nextElementSibling;
      if (next && next.classList && next.classList.contains(CONTAINER_CLASS)) return;

      const priceEl = priceBlock.querySelector('[id^="BruPdpPrice-"]') || priceBlock;
      const amount = parsePrice(priceEl.textContent);
      if (!amount) return;

      const container = document.createElement('div');
      container.className = CONTAINER_CLASS;
      container.style.margin = '10px 0 0';

      parent.insertBefore(container, next);

      if (window.paypal && window.paypal.Messages) {
        window.paypal
          .Messages({
            amount,
            placement: 'product',
            style: { layout: 'text' },
          })
          .render(container);
      }
    });
  };

  const init = () => {
    loadSdk()
      .then(insertMessages)
      .catch(() => {});
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    init();
  }
})();
